import en from './en.yml';
import cs from './cs.yml';

export default { cs, en };
